import React, { useState, useEffect } from 'react';
import classNames from 'classnames';
import { NavigationControl } from 'react-map-gl';
// components
import { Icons, Modal } from '../../../';
import { CustomMapControls } from '../CustomMapControls';
const defaultProps = {
    captureScroll: false,
    captureDrag: true,
    captureClick: true,
    captureDoubleClick: true,
    className: '',
};
export const MapControl = ({ navigationControl = { showCompass: true, showHome: true, showSearch: false, showSettings: false }, onControlInteraction = () => { }, translationData = {
    home: 'Back to Center',
    search: 'Search',
    addPin: 'Add Pin',
    removePin: 'Remove Pin',
    mapSettings: 'Map Settings',
    ruler: 'Ruler',
}, changeViewPort, resetView, isPinAdded = false, addPinToCentre = () => { }, dialogStatus = false, onDialogStateChange = () => { }, mapSettings = {
    update: () => { },
    reset: () => { },
    content: React.createElement("div", null, "Content will be added here..."),
}, addressSearch, closeSearch = false, rulerControl, }) => {
    const [showGeocoder, updateGeocoderStatus] = useState(dialogStatus);
    const [showSettingsModal, updateSettingsModal] = useState(false);
    const closeSearchDialouge = duration => {
        setTimeout(() => {
            updateGeocoderStatus(false);
            onDialogStateChange(false);
        }, duration);
    };
    const { showCompass, showHome, showSearch, showSettings } = navigationControl;
    useEffect(() => {
        if (closeSearch) {
            closeSearchDialouge(0);
        }
    }, [closeSearch]);
    if (!navigationControl) {
        return null;
    }
    return (React.createElement("div", { className: "navigation-control", onMouseEnter: () => {
            onDialogStateChange(true);
        }, onMouseLeave: () => {
            if (!showGeocoder) {
                onDialogStateChange(false);
            }
        } },
        showSearch && (React.createElement(CustomMapControls, Object.assign({}, defaultProps),
            React.createElement("button", { className: "navigation-control-home", title: translationData.search, onClick: () => {
                    const bool = !showGeocoder;
                    updateGeocoderStatus(bool);
                    onDialogStateChange(bool);
                    onControlInteraction('search');
                } },
                React.createElement(Icons, { size: 20, iconName: "ic-ui-search" })))),
        showSearch && (React.createElement(CustomMapControls, Object.assign({}, defaultProps),
            React.createElement("button", { className: classNames(`mapboxgl-ctrl-icon`, `mapboxgl-ctrl-pin`, {
                    active: isPinAdded,
                }), title: isPinAdded ? translationData.removePin : translationData.addPin, onClick: () => {
                    addPinToCentre();
                    onControlInteraction('pin');
                } },
                React.createElement(Icons, { size: 20, iconName: "ic-ui-pin", className: classNames(`pin-icon`, {
                        active: isPinAdded,
                    }) })))),
        showGeocoder && addressSearch && (React.createElement("div", { className: "mapboxgl-ctrl-top-right" },
            React.createElement("div", { className: "mapboxgl-ctrl-geocoder mapboxgl-ctrl" }, addressSearch))),
        showSettings && (React.createElement(CustomMapControls, Object.assign({}, defaultProps),
            React.createElement("button", { className: classNames(`mapboxgl-ctrl-settings`, {
                    active: showSettingsModal,
                }), title: translationData.mapSettings, onClick: () => {
                    updateSettingsModal(true);
                    onControlInteraction('settings');
                } },
                React.createElement(Icons, { size: 20, iconName: "ic-ui-map-layer" })))),
        showSettings && (React.createElement(Modal, { title: translationData.mapSettings, className: "mapboxgl-settings-modal", canOutsideClickClose: false, isOpen: showSettingsModal, handleUpdate: () => {
                mapSettings.update();
                updateSettingsModal(false);
            }, handleReset: () => {
                mapSettings.reset();
                updateSettingsModal(false);
            }, handleModalClose: () => {
                updateSettingsModal(false);
            } }, mapSettings.content)),
        React.createElement(NavigationControl, { style: { position: 'static' }, className: 'mapboxgl-ctrl mapboxgl-ctrl-group', onViewportChange: changeViewPort ? viewport => changeViewPort(viewport) : undefined, showCompass: showCompass }),
        rulerControl && (React.createElement(CustomMapControls, Object.assign({}, defaultProps),
            React.createElement("button", { title: translationData.ruler, className: classNames(`mapboxgl-ctrl-icon`, `mapboxgl-ctrl-pin`, {
                    active: rulerControl.isRulerEnabled,
                }), onClick: () => {
                    rulerControl.toggleRuler();
                } },
                React.createElement(Icons, { size: 20, iconName: "ic-ui-ruler", className: classNames(`pin-icon`, {
                        active: rulerControl.isRulerEnabled,
                    }) })))),
        showHome && resetView && (React.createElement(CustomMapControls, Object.assign({}, defaultProps),
            React.createElement("button", { title: translationData.home, className: "navigation-control-home", onClick: () => {
                    resetView();
                    onControlInteraction('home');
                } },
                React.createElement(Icons, { size: 20, iconName: "ic-ui-home" }))))));
};
//# sourceMappingURL=MapControl.js.map